import type { ProductMenuDef } from '../type.js';

/**
 * KARTE 基盤側で QANT プロダクト群の入口になるパス (issues = 旧 RightSupport のダッシュボード)。
 *
 * KARTE 基盤トップ (`/`) ではなくここへ送るのは、QANT ホストから KARTE-only プロジェクトへ
 * 切り替える利用者が見たいのは KARTE 本体の画面ではなく QANT プロダクトの画面だから。
 * QANT プロダクトが未有効な行は `resolveKarteOnlyProjectSwitchHref` が KARTE 本体へ振る。
 */
export const KARTE_QANT_ENTRY_PATH = '/rightsupport/';

/**
 * QANT プロダクト未有効な KARTE-only プロジェクトの入口（ユーザーリアルタイム）。
 * path に KARTE projectId を埋め、`?type=realtime` を付ける。
 */
export const buildKarteNativeUserRealtimePath = (karteProjectId: string): string => `/p/${encodeURIComponent(karteProjectId)}/user`;

/**
 * KARTE 基盤のプロジェクト設定 (アカウント管理) パス。
 * `?org=<KARTE organizationId>&project=<KARTE projectId>` の両方が要る。org を省くと KARTE 基盤は
 * project から組織を逆引きせず cookie `krt_current_org_id` で補完するため、直前に別組織を見ていた
 * 利用者がアクセス拒否になる (righttouch/systems#17963)。
 */
export const KARTE_PROJECT_SETTINGS_PATH = '/organization/project/accounts';

/** KARTE 基盤のアカウント設定パス。 */
export const KARTE_ACCOUNT_SETTINGS_PATH = '/account/setting';

/**
 * KARTE 本体 (連携プロダクト) の定義。
 *
 * QANT のプロダクトではなく Karte 基盤本体へのリンク。表示可否は condition ではなく
 * `normalize` が「信頼済み KARTE current が取得できているか (= current.organizationIds.karte)」で
 * 判定する。karte 側の enabledProducts の数には依存しない。
 *
 * QANT プロダクト群ではない外部プロダクトへの遷移なので、サブメニューは持たず
 * (`link` のみ)、クリックすると常に新規タブで KARTE 基盤本体を開く
 * (`options.openAnotherTab`)。どちらの基盤をホストにしていても同じ挙動。
 */
export const QANT_KARTE_MENU = {
  product: {
    name: 'karte',
    icon: 'qantKarte',
    label: { ja: 'KARTE', en: 'KARTE' },
    description: { ja: 'カスタマーデータ基盤', en: 'Customer Data Platform' },
    link: { path: { host: 'karte-io', path: '/' }, options: { openAnotherTab: true } },
  },
} as const satisfies ProductMenuDef;
